const parseFunction = (str) => {
  const isFunction = str.startsWith("func");

  const varNameType = isFunction ? "fun" : "text";
  const functionName = str.replace(/ *\([^)]*\) */g, "");

  const hasParams = str.includes("(") && str.includes(")");
  let params = [];
  if (hasParams) {
    params = str.split("(")[1].split(")")[0].split(",");
  }

  return {
    varNameType,
    variable_name_value: {
      name: functionName,
      params: params,
    },
  };
};

const parseVariables = (str) => {
  const arr = [];
  let word = "";
  let allow = false;
  for (let i = 0; i < str.length; i++) {
    const ch = str[i];
    if (ch === "[") {
      allow = true;
      continue;
    }
    if (ch === "]") {
      arr.push(word);
      allow = false;
      word = "";
      continue;
    }
    if (allow) word += ch;
  }
  return arr;
};

const stitchVariables = ({ name, params }) => {
  let str = name;
  for (let i = 0; i < params.length; i++) {
    if (i === 0) {
      str += `(`;
    }
    str += `${params[i]}`;
    if (i === params.length - 1) {
      str += `)`;
    } else {
      str += `,`;
    }
  }
  return str;
};

export { parseFunction, parseVariables, stitchVariables };
